import queryString from 'query-string';
import { updateCredentials } from '~/components/authentication/ducks/index.js';
import { cacheReferrer } from '~/components/account/ducks/index.js';
import {
	ROUTE_LOGIN,
	ROUTE_REGISTER,
	ROUTE_RESET_PASSWORD,
	ROUTE_RESET_PASSWORD_CODE,
	ROUTE_RESET_PASSWORD_DOB_VERIFICATION,
	ROUTE_RESET_PASSWORD_WELCOME,
	ROUTE_NEW_PASSWORD,
	ROUTE_PLAY_NOW
} from './constants.js';

const VALID_PATHS = [
	ROUTE_LOGIN,
	ROUTE_REGISTER,
	ROUTE_RESET_PASSWORD,
	ROUTE_RESET_PASSWORD_CODE,
	ROUTE_RESET_PASSWORD_DOB_VERIFICATION,
	ROUTE_RESET_PASSWORD_WELCOME,
	ROUTE_NEW_PASSWORD,
	ROUTE_PLAY_NOW
];

export const dataLayerChanges = location => {
	if (window.dataLayer) {
		const virtualPageUrl =
			window.location.pathname.substring(0, window.location.pathname.indexOf('/', 1)) +
			location.pathname +
			location.search +
			location.hash;
		window.dataLayer.push({
			event: 'virtualPageView',
			virtualPageviewUrl: virtualPageUrl
		});
	}
};

export const queryChanges = location => {
	/**
	 * location is read-only
	 * just copied the current implementation
	 * Future Work : Stop modifying  location and change the
	 * 				logic of reading query from location wherever used
	 */
	Object.assign(location, {
		query: queryString.parse(location.search)
	});
};

export const nonAuthenticatedChanges = (
	location,
	referrerLocation,
	authenticated,
	authenticationFrom,
	account,
	dispatch,
	router,
	contexts,
	closeAllContexts,
	basePathname
) => {
	// const _location = queryDecoder(location);

	const { pathname } = location;

	if (!pathname) {
		return;
	}

	if (VALID_PATHS.includes(pathname)) {
		/**
		 * if authentication is still in progress but authenticaton
		 * component is unmounted then don't overwrite it
		 */
		if (!authenticated) {
			/**
			 * if it's direct visit to '/login' path then router.location
			 * from redux store will be null
			 * make lastProduct or default product the referrer path
			 */

			const { implicit = false, from = referrerLocation } = location.state || {};
			if (VALID_PATHS.every(path => !referrerLocation.pathname.startsWith(path))) {
				/**
				 * if visit to /login is explicit i.e. clicking on login link
				 * It's safe to redirect back to referrer URL
				 * while exiting from authentication midway without sucessfully authenticating
				 * if referrer requires authentication then while exiting redirect back to
				 * referrer of referrer
				 *
				 */
				let exitPath;
				if (implicit) {
					if (referrerLocation.pathname === from.pathname) {
						exitPath = basePathname;
					} else {
						exitPath = referrerLocation;
					}
				} else {
					exitPath = from;
				}
				// const exitPath = implicit && referrerLocation.pathname === from.pathname ? baseLocation :
				const payload = {
					from,
					exitPath // : implicit ? referrerLocation : from
				};

				// Skip this if responsive and we're on landingpage for now
				// if (!isResponsive || from.pathname !== '/') {
				if (from.pathname !== '/') {
					// this sets from and exitPath on account state AND authentication
					dispatch(updateCredentials(payload));
				}
			}
			// } else if (isResponsive && pathname !== '/login') {
		} else if (pathname !== '/login') {
			closeAllContexts();
		}
	}
	/**
	 * ofcourse duplicating it for time being
	 */

	if (pathname.startsWith('/account')) {
		if (!account.from) {
			/**
			 * mind boggling logic, will make it concise.
			 * it tries to do following,
			 * - Don't assign referrer from privatepath (account)
			 * - safegaurd full page reload
			 */

			const referrer = location || basePathname;
			const { pathname: referrerPathname } =
				// (isResponsive && queryDecoder(referrer)) ||
				// referrer;
				contexts.map(({ queryDecoder }) => queryDecoder(referrer)).find(Boolean) || referrer;
			const referrerFromAccount = referrerPathname.startsWith('/account');

			const from = authenticationFrom && !referrerFromAccount ? referrer : basePathname;

			dispatch(
				cacheReferrer({
					from
				})
			);
		}
	}
};
